<ion-header>
  <ion-toolbar>
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-text-center ion-padding">

  <h3>Convierte automáticamente tus puntos en saldo</h3>
  <p class="ion-margin-top">
    <b>¿Como funciona?</b>
  </p>
  <p>
    Cada vez que acumules puntos, estos se convertirán automáticamente en saldo en tu billetera. Este proceso puede
    tardar hasta 24 horas. Después de ese tiempo, verás reflejado el saldo en tu cuenta y se descontarán los puntos
    correspondientes.
  </p>

  <p class="ion-margin-top">
    <b>
      ¿Quieres activar esta opción?
    </b>
  </p>

  <div class="botones-container">
    <ion-button *ngIf="showDeactivateButton" (click)="automaticRedemptionUpdate(false)">{{deactivateText}}</ion-button>
    <ion-button *ngIf="showActivateButton" (click)="automaticRedemptionUpdate(true)">Activar</ion-button>
  </div>


</ion-content>